import { parsePatientJsonField } from "../Support/validators/helper/patientFields";

function asText(value) {
  if (value == null) return null;
  if (typeof value === "number" && Number.isFinite(value)) return String(value);
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  if (!trimmed || trimmed.toLowerCase() === "null") return null;
  return trimmed;
}

function asObject(value) {
  const data = parsePatientJsonField(value);
  return data && typeof data === "object" && !Array.isArray(data) ? data : null;
}

function providerDidSelect(mdmSelected) {
  if (!mdmSelected) return false;
  return Boolean(asText(mdmSelected.final_code) || asText(mdmSelected.final_level));
}

export function getEandMComparison(patient = {}) {
  const mdmSelected = asObject(patient.mdm_selected);
  const eAndM = asObject(patient.e_and_m);
  const selected = providerDidSelect(mdmSelected);
  const finalCode = asText(mdmSelected?.final_code);
  const knowtexCode = asText(eAndM?.e_and_m_code);
  const rationale = asText(mdmSelected?.override_rationale);
  const codesDiffer = Boolean(finalCode && knowtexCode && finalCode !== knowtexCode);

  return {
    providerSelected: selected,
    finalCode,
    knowtexCode,
    overrideRationale: codesDiffer ? rationale : null,
  };
}

export function getPatientStarRating(userFeedback) {
  const data = parsePatientJsonField(userFeedback);
  if (data == null) return { rating: null, additionalFeedback: null };

  if (typeof data === "number") {
    return {
      rating: Number.isFinite(data) ? data : null,
      additionalFeedback: null,
    };
  }

  if (typeof data === "string" && /^\d+(\.\d+)?$/.test(data.trim())) {
    return { rating: Number(data.trim()), additionalFeedback: null };
  }

  if (typeof data !== "object") {
    return { rating: null, additionalFeedback: null };
  }

  const raw = data.rating;
  let rating = null;
  if (raw != null && /^\d+(\.\d+)?$/.test(String(raw).trim())) {
    rating = Number(raw);
  }

  const additionalFeedback =
    typeof data.additional_feedback === "string" && data.additional_feedback.trim()
      ? data.additional_feedback.trim()
      : null;

  return { rating, additionalFeedback };
}

export function formatCodeOrDash(code) {
  return code || "—";
}
